// Mirrors KFCStKitts/Managers/CommissionCalculator.swift.
// Rates and formulas must stay identical across web and iOS.

export const PLATFORM_COMMISSION_RATE = 0.10; // 10% of food subtotal
export const DRIVER_COMMISSION_RATE = 0.10;   // platform keeps 10% of delivery fee
export const CHEF_SERVICE_FEE_RATE = 0.02;    // 2% of food subtotal

// Delivery fee schedule — mirrors Helpers/DeliveryFeeCalculator.swift.
// $15 base covers the first mile, then $3 for each additional mile.
export const DELIVERY_BASE_FEE = 15.0;
export const DELIVERY_RATE_PER_MILE = 3.0;
export const DELIVERY_MINIMUM_FEE = 15.0;

export const round2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

// iOS: max(minimumFee, ceil(base + ratePerMile * max(0, miles - 1)))
export function deliveryFeeForMiles(distanceMiles) {
  const miles = Math.max(0, Number(distanceMiles) || 0);
  const extraMiles = Math.max(0, miles - 1);
  const raw = DELIVERY_BASE_FEE + DELIVERY_RATE_PER_MILE * extraMiles;
  const fee = Math.max(DELIVERY_MINIMUM_FEE, Math.ceil(raw));
  console.log('[DeliveryFee]', {
    distanceMiles: miles.toFixed(3),
    baseFee: DELIVERY_BASE_FEE,
    extraMiles: extraMiles.toFixed(3),
    ratePerMile: DELIVERY_RATE_PER_MILE,
    rawFee: raw.toFixed(2),
    minimum: DELIVERY_MINIMUM_FEE,
    finalFee: fee,
  });
  return fee;
}

// Mirrors CommissionCalculator.computeBreakdown — iOS writes all of these
// fields onto the order document at creation time.
export function computeOrderBreakdown({ subtotal, deliveryFee = 0, orderType }) {
  const isDelivery = String(orderType || '').toLowerCase() === 'delivery';
  const fee = isDelivery ? round2(deliveryFee) : 0;

  const chefServiceFee = round2(subtotal * CHEF_SERVICE_FEE_RATE);
  const platformCommissionFromRestaurant = round2(subtotal * PLATFORM_COMMISSION_RATE);
  const driverPayout = round2(fee * (1 - DRIVER_COMMISSION_RATE));

  return {
    subtotal: round2(subtotal),
    chefServiceFee,
    // iOS stores only the food-side commission here; the delivery-side 10%
    // is folded in when the driver accepts (see driver orderService).
    platformCommission: platformCommissionFromRestaurant,
    driverCommission: driverPayout,
    restaurantPayout: round2(subtotal - platformCommissionFromRestaurant),
    driverPayout,
    totalAmount: round2(subtotal + chefServiceFee + fee),
  };
}
